import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IceapiService } from '../../../../services';
import { DataService } from '../../../../services/data.service';
import { CalculationType } from '../../enums/calculation-type.enum';
import { TighteningMethod } from '../../enums/tightening-method.enum';
import { DimensionOverridesInput, ProcessInfoData, StdInputData, TighteningData } from '../../models';
import { CalculationResult } from '../../models/calculationModels/calculation-result';
import { InputGroup } from '../../models/calculationModels/input-group';
import { ToolOutput } from '../../models/calculationModels/tool-output';
import { ControlData } from '../../models/control-data';
import { DiagramDataModel } from '../../models/diagram-data-model';
import { DiagramInfo } from '../../models/diagram-info';
import { SubHeaderData } from '../../models/sub-header-data';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
@Component({
    selector: 'app-custom-flange',
    templateUrl: './custom-flange.component.html',
    styleUrls: ['./custom-flange.component.scss'],
})
export class CustomFlangeComponent implements OnInit {
    @Input() cssClass;
    @ViewChild('panel1') panel1;
    @ViewChild('panel2') panel2;
    @ViewChild('panel3') panel3;
    @ViewChild('panel4') panel4;
    @ViewChild('beginbtn', { static: false }) beginbtn: ElementRef;
    destroy$ = new Subject();

    subHeaderData: SubHeaderData;
    customFlangeInput: InputGroup;
    calculationResult: CalculationResult;
    toolsData: ToolOutput[];
    diagramInfo: DiagramDataModel;
    isInputValid: boolean = false;
    isInitialFormLoad: boolean = true;
    isTighteningInputValid: boolean = false;
    isCustomInputValid: boolean = false;
    isProcessInfoInputValid: boolean = false;
    isOverrideFlangeValid: boolean = false;
    isOverrideFlangeFacingValid: boolean = false;
    isOverrideGasketValid: boolean = false;
    outputTabIndex = 0;
    selectedTool: ToolOutput;
    hideAdvanceOptionTab: boolean = false;
    tooltip_position = 'above';
    tighteningform = false;
    customForm = false;
    processform = false;
    toolsform = false;
    showpaneltoggle = false;
    showPanelUnitToggle = false;
    editpanel_1 = false;
    editpanel_2 = false;
    editpanel_3 = false;
    editpanel_4 = false;
    isRedirect: string = 'false';
    processInfoForm: UntypedFormGroup;
    customInputForm: UntypedFormGroup;
    tighteningProcedureForm: UntypedFormGroup;
    toolsFormGroup: UntypedFormGroup;
    IsCalculationOutPutTabSelected: boolean = false;
    LoadCalculationSubscription: Subscription;
    isCalculationDone: boolean;
    isTighFormValid: boolean = false;
    isCustomFormValid: boolean = false;
    isProcessFormValid: boolean = false;

    constructor(
        private iceapi: IceapiService,
        private renderer: Renderer2,
        private route: ActivatedRoute,
        private dataSvc: DataService,
        private router: Router,
        private cd: ChangeDetectorRef,
        private ngxUiLoaderService: NgxUiLoaderService,
        private globalEmittersService: GlobalEmittersService,
        private user_utility: UserUtilityService,
                 private translocoService: TranslocoService
    ) {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    }

    ngOnInit() {
        this.subHeaderData = this.setSubHeaderValues();
        this.customFlangeInput = new InputGroup();
        this.customFlangeInput.dimensionOverrides = new DimensionOverridesInput();
        this.diagramInfo = new DiagramDataModel();
        this.diagramInfo.isEditable = true;

        this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
            this.isRedirect = params['isRedirect'];
        });
        if (this.isRedirect == 'true') {
            this.ngxUiLoaderService.start();
            this.calculationResult = this.dataSvc?.calculationData;
            this.customFlangeInput = this.dataSvc?.calculationData?.input;
            this.toolsData = this.dataSvc?.calculationData?.output?.tools;
            this.isInitialFormLoad = false;
            this.editpanel_1 = true;
            this.editpanel_2 = true;
            this.editpanel_3 = true;
            this.editpanel_4 = true;
            this.tighteningform = true;
            this.customForm = true;
            this.processform = true;
            this.toolsform = true;
            this.isTighteningInputValid = true;
            this.isCustomInputValid = true;
            this.isProcessInfoInputValid = true;
            this.isOverrideFlangeFacingValid = true;
            this.isOverrideFlangeValid = true;
            this.isOverrideGasketValid = true;
            this.isInputValid = true;
            this.globalEmittersService.isCalculationHappen.next(true); // * this is used for tools component to display conditional based warning

            this.isCalculationDone = true;
            this.ngxUiLoaderService.stop();
        } else {
            this.customFlangeInput = new InputGroup();
            this.customFlangeInput.dimensionOverrides = new DimensionOverridesInput();
            this.dataSvc.calculationData = null;
            this.globalEmittersService.isCalculationHappen.next(false); // * this is used for tools component to display conditional based warning
        }

        this.globalEmittersService.currentCalculationType.next(CalculationType.CustomFlange);

        this.globalEmittersService.openControlProcedurePanel.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.showPanel1And2();
            }
        });

        this.globalEmittersService.processInfoForm.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.processInfoForm = res;
            res?.valueChanges?.pipe(takeUntil(this.destroy$)).subscribe((val) => {
                if (val && this.isCalculationDone) {
                    this.isProcessFormValid = false;
                }
            });
        });

        this.globalEmittersService.customInputForm.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.customInputForm = res;
            res?.valueChanges?.pipe(takeUntil(this.destroy$)).subscribe((val) => {
                if (val && this.isCalculationDone) {
                    this.isCustomFormValid = false;
                }
            });
        });

        this.globalEmittersService.tighteningProcedureForm.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.tighteningProcedureForm = res;
            res?.valueChanges?.pipe(takeUntil(this.destroy$)).subscribe((val) => {
                if (val && this.isCalculationDone) {
                    this.isTighFormValid = false;
                }
            });
        });

        this.globalEmittersService.toolsFormGroup.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.toolsFormGroup = res;
        });

        this.LoadCalculationSubscription = this.globalEmittersService.LoadCalculation.pipe(takeUntil(this.destroy$)).subscribe((data: boolean) => {
            if (data) {
                this.btnCalculateClicked();
                if (this.selectedTool) {
                    this.globalEmittersService.ManufactureName.next(this.selectedTool.manufacturer.name);
                    this.globalEmittersService.ToolSelectedId.next(this.selectedTool.id);
                    this.IsCalculationOutPutTabSelected = true;
                }
            }
        });

        this.globalEmittersService.isCalculationHappen.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.checkHideOption();
        });
    }

    checkHideOption() {
        if (this.calculationResult?.output) {
            this.hideAdvanceOptionTab = true;
        }
        if (this.calculationResult?.output?.general?.warnings) {
            let res = this.calculationResult.output.general.warnings.some((w) => w.severity <= 1);
            if (res === true) {
                this.hideAdvanceOptionTab = false;
                this.cd.detectChanges();
            }
        }
    }

    setSubHeaderValues(): SubHeaderData {
        let headerData = new SubHeaderData();
        headerData.displayText = this.translocoService.translate('HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.CUSTOM_FLANGE');
        headerData.disableActions = true;
        headerData.defaultImageSrc = '../../../../../../assets/media/logos/custom-black-button.png';
        headerData.mouseOverImageSrc = '../../../../../../assets/media/logos/custom-yellow-button.png';
        return headerData;
    }

    tighteningDataHandler(tighteningData: TighteningData) {
        if (tighteningData.isDataValid) {
            this.customFlangeInput.others.tighteningMethod = tighteningData.tighteningMethod;
            this.customFlangeInput.others.breakout = tighteningData.breakout;
            this.customFlangeInput.others.percentageCover = tighteningData.percentageCover;
            this.customFlangeInput.others.lubricantMode = tighteningData.lubricantMode;
            this.customFlangeInput.recordId.lubricantId = tighteningData.lubricantId;
            this.customFlangeInput.calculationOverrides.kFactor = tighteningData.kFactor;
            this.isTighteningInputValid = true;
            this.isTighFormValid = true;
        } else {
            this.isTighteningInputValid = false;
        }
        if (!this.editpanel_1) {
            this.panel2.open();
        }
        this.editpanel_1 = true;
        this.tighteningform = false;
        this.panel1.close();
        this.setValidity();
    }

    customFlangeDataHandler(customInput: StdInputData) {
        if (customInput.isDataValid) {
            // this.customFlangeInput.dimensionOverrides = new DimensionOverridesInput();
            this.customFlangeInput.recordId.flangeTypeId1 = customInput.flangeTypeId1;
            this.customFlangeInput.recordId.flangeTypeId2 = customInput.flangeTypeId1;
            this.customFlangeInput.recordId.flangeFacingTypeId = customInput.flangeFacingTypeId;
            this.customFlangeInput.recordId.flangeMaterialId1 = customInput.flangeMaterialId1;
            this.customFlangeInput.recordId.gasketId = customInput.gasketId;
            this.customFlangeInput.recordId.boltMaterialId = customInput.boltMaterialId;
            this.customFlangeInput.recordId.additionalThicknessId = customInput.additionalThicknessId;
            this.customFlangeInput.recordId.boltDimensionId = customInput.boltDimensionId;
            this.customFlangeInput.recordId.nutDimensionId = customInput.nutDimensionId;
            this.customFlangeInput.recordId.washerDimensionId = customInput.washerThickness;

            this.customFlangeInput.others.tighteningSpecification = customInput.tighteningSpecification;
            this.customFlangeInput.others.tighteningSpecificationInput = customInput.tighteningSpecificationInput;
            this.customFlangeInput.others.boltType = customInput.boltType;
            this.customFlangeInput.others.boltQuantity = customInput.boltQuantity;
            this.customFlangeInput.others.threadType = customInput.threadType;

            this.customFlangeInput.calculationOverrides.standard = customInput.customStandardName;
            this.customFlangeInput.calculationOverrides.pipeSize = customInput.customPipeSizeName;
            this.customFlangeInput.calculationOverrides.pipeSchedule = customInput.customPipeScheduleName;
            this.customFlangeInput.calculationOverrides.additionalThickness = customInput.additionalThickness;
            customInput?.isRedAreaBoltSelected
                ? (this.customFlangeInput.calculationOverrides.minimumBoltDiameter = customInput?.minimumBoltDiameter)
                : (this.customFlangeInput.calculationOverrides.minimumBoltDiameter = undefined);

            customInput?.isRedAreaBoltSelected
                ? (this.customFlangeInput.dimensionOverrides.reducedAreaBolting = customInput?.minimumBoltDiameter)
                : (this.customFlangeInput.dimensionOverrides.reducedAreaBolting = undefined);

            this.customFlangeInput.calculationOverrides.recommendedGasketStress = customInput.recommendedGasketStress;
            this.customFlangeInput.calculationOverrides.minimumGasketStress = customInput.minimumGasketStress;
            this.customFlangeInput.calculationOverrides.maximumGasketStress = customInput.maximumGasketStress;
            this.customFlangeInput.calculationOverrides.y = customInput.y;
            this.customFlangeInput.calculationOverrides.m = customInput.m;
            this.customFlangeInput.calculationOverrides.pAdditional = customInput.pAdditional;
            this.isCustomInputValid = true;
            this.isCustomFormValid = true;
            this.customFlangeInput.recordId.boltMaterialAliasId = customInput.boltMaterialAliasId==undefined || customInput.boltMaterialAliasId==null || customInput.boltMaterialAliasId=='' ? null: customInput.boltMaterialAliasId;       
            this.customFlangeInput.recordId.flangeMaterialAliasId1 =customInput.flangeMaterialAliasId1==undefined || customInput.flangeMaterialAliasId1==null || customInput.flangeMaterialAliasId1=='' ? null:customInput.flangeMaterialAliasId1;  
            this.customFlangeInput.recordId.flangeMaterialAliasId2 = customInput.flangeMaterialAliasId2==undefined || customInput.flangeMaterialAliasId2==null || customInput.flangeMaterialAliasId2=='' ? null: customInput.flangeMaterialAliasId2;              
            this.customFlangeInput.recordId.gasketAliasId = customInput.gasketAliasId==undefined || customInput.gasketAliasId==null || customInput.gasketAliasId=='' ? null:customInput.gasketAliasId;            
          


        } else {
            this.isCustomInputValid = false;
        }
        if (!this.editpanel_2) {
            this.panel3.open();
        }
        this.editpanel_2 = true;
        this.customForm = false;
        this.panel2.close();
        this.setValidity();
    }

    processInfoDataHandler(processInfoData: ProcessInfoData) {
        if (processInfoData.isDataValid) {
            this.customFlangeInput.calculationOverrides.operatingTemperature = processInfoData.operatingTemperature;
            this.customFlangeInput.calculationOverrides.operatingPressure = processInfoData.operatingPressure;
            this.customFlangeInput.calculationOverrides.testPressure = processInfoData.testPressure;
            this.isProcessInfoInputValid = true;
            this.isProcessFormValid = true;
        } else {
            this.isProcessInfoInputValid = false;
        }
        if (!this.editpanel_3) {
            this.panel4.open();
        }
        this.editpanel_3 = true;
        this.processform = false;
        this.panel3.close();
        this.setValidity();
    }

    toolsDataHandler(nearestObstruction: string) {
        this.customFlangeInput.calculationOverrides.distanceToNearestObstruction = nearestObstruction;
    }

    selectedToolDataHandler(selectedToolId: string) {
        this.calculationResult.output.tools.forEach((x) => (x.isSelected = false));
        this.calculationResult.output.tools.find((x) => x.id === selectedToolId).isSelected = true;
        this.selectedTool = this.calculationResult.output.tools.find((x) => x.id === selectedToolId);
        this.dataSvc.selectedToolId = selectedToolId;
        this.outputTabIndex = 1;
    }

    async invokeCalculate(inputGroup: InputGroup) {
        this.tighteningform = false;
        this.customForm = false;
        this.processform = false;
        await this.iceapi
            .postCalculateStandardFlange(inputGroup)
            .toPromise()
            .then((res) => {
                if (res.success === true) {
                    if (!this.editpanel_3) {
                        this.panel4.open();
                    }
                    this.editpanel_3 = true;
                    this.panel3.close();
                    this.calculationResult = res.response;
                    if (res.response.calculationSucceeded) {
                        this.globalEmittersService.isCalculationHappen.next(true); // * this is used for tools component to display conditional based warning
                        this.customFlangeInput.calculationOverrides.minimumBoltDiameter = undefined;
                        this.toolsData = this.calculationResult.output.tools;
                        if (!this.toolsData.length) {
                            this.outputTabIndex = 1;
                        }
                        this.subHeaderData.disableActions = false;
                        this.outputTabIndex = 0;
                        if (this.IsCalculationOutPutTabSelected) {
                            this.outputTabIndex = 1;
                        }
                        this.isCalculationDone = true;
                    } else {
                        this.globalEmittersService.isCalculationHappen.next(false);
                    }
                    this.cd.markForCheck();
                } else {
                    this.globalEmittersService.isCalculationHappen.next(false);
                    this.user_utility.errorModelPopup(res.message);
                }
            })
            .catch(() => {
                this.globalEmittersService.isCalculationHappen.next(false);
                this.ngxUiLoaderService.stop();
            });
    }

    disableButton() {
        if (this.customInputForm?.valid || this.processInfoForm?.valid || this.tighteningProcedureForm?.valid || this.toolsFormGroup?.valid) {
            if (this.isOverrideGasketValid && this.isOverrideFlangeValid && this.isOverrideFlangeFacingValid) {
                return true;
            }
        }
    }

    diagramDataHandler(diagramInfo: DiagramInfo) {
        switch (diagramInfo.diagramType) {
            case 'Flange':
                // this.diagramInfo=new DiagramDataModel;
                this.diagramInfo.isEditable = true;
                if (diagramInfo.diagramId.length || diagramInfo.flangeTypeId) {
                    this.diagramInfo.isDiagramsAdded = true;

                    this.diagramInfo.flange = diagramInfo;
                } else {
                    this.diagramInfo.flange = null;
                }
                break;
            case 'Flange Facing':
                if (diagramInfo.diagramId.length || diagramInfo.flangeFacingTypeId) {
                    this.diagramInfo.isDiagramsAdded = true;
                    this.diagramInfo.flangeFacing = diagramInfo;
                } else {
                    this.diagramInfo.flangeFacing = null;
                }
                break;
            case 'Gasket':
                if (diagramInfo.diagramId.length || diagramInfo.gasketTypeId) this.diagramInfo.isDiagramsAdded = true;
                this.diagramInfo.gasket = diagramInfo;
                break;
            case 'Bolt Setting':
                if (diagramInfo?.name) {
                    this.diagramInfo.isDiagramsAdded = true;
                    this.diagramInfo.boltSettingsName = diagramInfo.name;
                    this.diagramInfo.torqueSequenceName = undefined;
                } else {
                    this.diagramInfo.boltSettingsName = undefined;
                    this.diagramInfo.torqueSequenceName = undefined;
                    // this.diagramInfo.isDiagramsAdded = false;
                }
                break;
            case 'Torque Sequence':
                if (this.customFlangeInput.others.tighteningMethod == TighteningMethod.Torque) {
                    if (diagramInfo.noOfBolts <= 0) {
                        diagramInfo.noOfBolts = this.customFlangeInput.others.boltQuantity;
                    }
                    if (diagramInfo.noOfBolts !== undefined && diagramInfo.noOfBolts !== null) {
                        this.diagramInfo.isDiagramsAdded = true;
                        this.diagramInfo.torqueSequenceName = diagramInfo.noOfBolts + 'Hole';
                    }
                    this.diagramInfo.boltSettingsName = undefined;
                }
                break;
            case 'Tool Diagram':
                this.diagramInfo.tool = diagramInfo;
                this.diagramInfo.isDiagramsAdded = true;
                break;
            case 'Tool Image':
                this.diagramInfo.toolImage = diagramInfo;
                this.diagramInfo.isDiagramsAdded = true;
                break;
        }
    }

    DiagramFormDataHandler(event) {
        for (const key in event.value) {
            const value = event.value[key];
            if (!(key in this.customFlangeInput.dimensionOverrides) && (value != null || value != undefined)) {
                this.customFlangeInput.dimensionOverrides[key] = event.value[key];
            }
            if (value === '' || value == null) {
                delete this.customFlangeInput.dimensionOverrides[key];
            } else {
                this.customFlangeInput.dimensionOverrides[key] = value;
            }
        }
    }

    diagramControlDataHandler(controlData: ControlData) {
        switch (controlData.controlName) {
            case 'flangeBoltHoleDiameter':
                this.customFlangeInput.dimensionOverrides.flangeBoltHoleDiameter = controlData.controlValue;
                this.isOverrideFlangeValid = controlData.isFormValid;
                break;
            case 'flangeHeight':
                this.customFlangeInput.dimensionOverrides.flangeHeight = controlData.controlValue;
                this.isOverrideFlangeValid = controlData.isFormValid;
                break;
            case 'flangeHubDiameter':
                this.customFlangeInput.dimensionOverrides.flangeHubDiameter = controlData.controlValue;
                this.isOverrideFlangeValid = controlData.isFormValid;
                break;
            case 'flangeNeckOD':
                this.customFlangeInput.dimensionOverrides.flangeNeckOD = controlData.controlValue;
                this.isOverrideFlangeValid = controlData.isFormValid;
                break;
            case 'flangeOD':
                this.customFlangeInput.dimensionOverrides.flangeOD = controlData.controlValue;
                this.isOverrideFlangeValid = controlData.isFormValid;
                break;
            case 'flangePCD':
                this.customFlangeInput.dimensionOverrides.flangePCD = controlData.controlValue;
                this.isOverrideFlangeValid = controlData.isFormValid;
                break;
            case 'flangeThickness':
                this.customFlangeInput.dimensionOverrides.flangeThickness = controlData.controlValue;
                this.isOverrideFlangeValid = controlData.isFormValid;
                break;
            case 'flangeSocketID':
                this.customFlangeInput.dimensionOverrides.flangeSocketID = controlData.controlValue;
                this.isOverrideFlangeValid = controlData.isFormValid;
                break;
            case 'flangeID':
                this.customFlangeInput.dimensionOverrides.flangeID = controlData.controlValue;
                this.isOverrideFlangeValid = controlData.isFormValid;
                break;

            case 'grooveDepth':
                this.customFlangeInput.dimensionOverrides.grooveDepth = controlData.controlValue;
                this.isOverrideFlangeFacingValid = controlData.isFormValid;
                break;
            case 'outerRFOD':
                this.customFlangeInput.dimensionOverrides.outerRFOD = controlData.controlValue;
                this.isOverrideFlangeFacingValid = controlData.isFormValid;
                break;
            case 'pitchDiameter':
                this.customFlangeInput.dimensionOverrides.pitchDiameter = controlData.controlValue;
                this.isOverrideFlangeFacingValid = controlData.isFormValid;
                break;
            case 'reducedAreaBolting':
                this.customFlangeInput.dimensionOverrides.reducedAreaBolting = controlData.controlValue;
                this.isOverrideFlangeFacingValid = controlData.isFormValid;
                break;
            case 'rFDepth':
                this.customFlangeInput.dimensionOverrides.rFDepth = controlData.controlValue;
                this.isOverrideFlangeFacingValid = controlData.isFormValid;
                break;
            case 'rFID':
                this.customFlangeInput.dimensionOverrides.rFID = controlData.controlValue;
                this.isOverrideFlangeFacingValid = controlData.isFormValid;
                break;
            case 'rFOD':
                this.customFlangeInput.dimensionOverrides.rFOD = controlData.controlValue;
                this.isOverrideFlangeFacingValid = controlData.isFormValid;
                break;
            case 'rFThickness':
                this.customFlangeInput.dimensionOverrides.rFThickness = controlData.controlValue;
                this.isOverrideFlangeFacingValid = controlData.isFormValid;
                break;

            case 'gasketHeight':
                this.customFlangeInput.dimensionOverrides.gasketHeight = controlData.controlValue;
                this.isOverrideGasketValid = controlData.isFormValid;
                break;
            case 'gasketID':
                this.customFlangeInput.dimensionOverrides.gasketID = controlData.controlValue;
                this.isOverrideGasketValid = controlData.isFormValid;
                break;
            case 'gasketOD':
                this.customFlangeInput.dimensionOverrides.gasketOD = controlData.controlValue;
                this.isOverrideGasketValid = controlData.isFormValid;
                break;
            case 'gasketPitchDiameter':
                this.customFlangeInput.dimensionOverrides.gasketPitchDiameter = controlData.controlValue;
                this.isOverrideGasketValid = controlData.isFormValid;
                break;
            case 'gasketRingID':
                this.customFlangeInput.dimensionOverrides.gasketRingID = controlData.controlValue;
                this.isOverrideGasketValid = controlData.isFormValid;
                break;
            case 'gasketRingOD':
                this.customFlangeInput.dimensionOverrides.gasketRingOD = controlData.controlValue;
                this.isOverrideGasketValid = controlData.isFormValid;
                break;
            case 'gasketWidth':
                this.customFlangeInput.dimensionOverrides.gasketWidth = controlData.controlValue;
                this.isOverrideGasketValid = controlData.isFormValid;
                break;
            case 'gasketDegrees':
                this.customFlangeInput.dimensionOverrides.gasketDegrees = controlData.controlValue;
                this.isOverrideGasketValid = controlData.isFormValid;
                break;
            case 'gasketThickness':
                this.customFlangeInput.dimensionOverrides.gasketThickness = controlData.controlValue;
                this.isOverrideGasketValid = controlData.isFormValid;
                break;
            case 'widthOfFlat':
                this.customFlangeInput.dimensionOverrides.widthOfFlat = controlData.controlValue;
                this.isOverrideGasketValid = controlData.isFormValid;
                break;
        }
        this.setValidity();
    }

    btnCalculateClicked() {
        this.globalEmittersService.refreshWarnings.next(true);
        if (this.isInputValid || this.isRedirect == 'true') {
            this.ngxUiLoaderService.start();
            this.customFlangeInput.calculationType = CalculationType.CustomFlange;
            if (!this.customFlangeInput.calculationOverrides.distanceToNearestObstruction) {
                this.customFlangeInput.calculationOverrides.distanceToNearestObstruction = '1000 mm';
            }
            this.invokeCalculate(this.customFlangeInput).then(
                () => {
                    this.ngxUiLoaderService.stop();
                    this.iceapi.calculationRes.next(true);
                    this.globalEmittersService.refreshTools.next(true);
                },
                () => {
                    this.ngxUiLoaderService.stop();
                }
            );
        }
    }

    setValidity() {
        if (
            this.isTighteningInputValid &&
            this.isCustomInputValid &&
            this.isProcessInfoInputValid &&
            this.isOverrideFlangeValid &&
            this.isOverrideFlangeFacingValid &&
            this.isOverrideGasketValid
        ) {
            this.isInputValid = true;
        } else {
            this.isInputValid = false;
        }
    }

    beginform() {
        this.isInitialFormLoad = false;
        this.tighteningform = true;
        this.customForm = false;
        this.processform = false;
        this.toolsform = false;
        this.renderer.addClass(this.beginbtn.nativeElement, 'active');
    }

    showPanel1() {
        if (this.editpanel_1 == true) this.tighteningform = true;
        this.customForm = false;
        this.processform = false;
        this.toolsform = false;
    }

    showPanel2() {
        if (this.tighteningProcedureForm.valid) {
            this.tighteningform = false;
            this.customForm = true;
            this.processform = false;
            this.toolsform = false;
        }
    }

    showPanel3() {
        if (this.customInputForm.valid) {
            this.tighteningform = false;
            this.customForm = false;
            this.processform = true;
            this.toolsform = false;
        }
    }

    showPanel4() {
        if (this.processInfoForm.valid) {
            this.tighteningform = false;
            this.customForm = false;
            this.toolsform = true;
        }
    }

    showpanel() {
        this.showpaneltoggle = !this.showpaneltoggle;
    }

    showPanel1And2() {
        this.tighteningform = true;
        this.customForm = true;
        this.processform = false;
        this.toolsform = false;
    }

    hidepanelclose() {
        this.showpaneltoggle = false;
    }

    showUnitpanel() {
        this.showPanelUnitToggle = !this.showPanelUnitToggle;
    }

    hideUnitpanelClose() {
        this.showPanelUnitToggle = false;
    }
}
